module.exports = __webpack_public_path__ + "img/jk1.572978fd.png";